module.exports = __webpack_public_path__ + "img/companyregistrationcertificatehongkong.fc425171.jpg";